// src/app/core/util/geo-utils.ts

/**
 * Calculates the centroid (midpoint) of a GeoJSON Polygon.
 * Works for simple polygons (first ring used).
 * @param coords - Array of [lng, lat] coordinates (outer ring)
 * @returns [lng, lat] centroid point
 */
export function calculatePolygonCentroid(coords: number[][]): [number, number] {
  if (!coords || coords.length === 0) {
    throw new Error('Invalid coordinates array provided.');
  }

  let xSum = 0;
  let ySum = 0;
  const numPoints = coords.length;

  coords.forEach(([lng, lat]) => {
    xSum += lng;
    ySum += lat;
  });

  const centroid: [number, number] = [xSum / numPoints, ySum / numPoints];
  return centroid;
}
